import { render } from "./FoodBarnSection.vue?vue&type=template&id=1f85ada2&ts=true"
import script from "./FoodBarnSection.vue?vue&type=script&lang=ts"
export * from "./FoodBarnSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__